import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Marquee = ({ text }) => (
  <div className="overflow-hidden bg-[#B5472B] py-3 select-none" data-testid="editorial-marquee">
    <div className="animate-marquee flex whitespace-nowrap">
      {[0, 1].map((i) => (
        <span key={i} className="font-serif italic text-[#F6EFE4] text-lg sm:text-xl tracking-wide px-4">
          {text.repeat(4)}
        </span>
      ))}
    </div>
  </div>
);
